import React, { FC, useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';

import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import SsidChartOutlinedIcon from '@mui/icons-material/SsidChartOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

import { Routes, Route, Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router';

import { isAdmin } from '../utils/auth';
import { Footer } from '../components/Footer';
import { Charts } from '../components/Charts';
import { Channels } from '../components/Channels';
import { Devices } from '../components/Devices';
import { ChartDialog } from '../components/ChartDialog';
import { DataList } from '../components/DataList';
import { ExportDialog } from '../components/ExportDialog';
import { EditUsers } from '../components/EditUsers';
import { EditDevices } from '../components/EditDevices';
import { EditGroups } from '../components/EditGroups';
import { EditChannels } from '../components/EditChannels';
import { EditSensorTypes } from '../components/EditSensorTypes';
import { EditDeviceTypes } from '../components/EditDeviceTypes';
import { EditDeviceTypeChannels } from '../components/EditDeviceTypeChannels';
//import { toLocal } from '../utils/dateUtils'

const Title_Channels='地点監視'
const Title_Devices='端末管理'
const Title_DataList='データ一覧表示'
const Title_EditUsers='ユーザー設定'
const Title_EditDevices='端末設定'
const Title_EditChannels='地点設定'
const Title_EditGroups='グループ設定'
const Title_EditSensorTypes='センサ種別設定'
const Title_EditDeviceTypes='端末種別設定'
const Title_EditDeviceTypeChannels='端末種別チャネル設定'
const Title_Exports='エクスポート'
const Title_Charts='グラフ表示'

const Endpoits_Channels='channels'
const Endpoits_Devices='devices'
const Endpoits_DataList='datalist'
const Endpoits_EditUsers='edit_users'
const Endpoits_EditDevices='edit_devices'
const Endpoits_EditChannels='edit_channels'
const Endpoits_EditGroups='edit_groups'
const Endpoits_EditSensorTypes='edit_sensor_types'
const Endpoits_EditDeviceTypes='edit_device_types'
const Endpoits_EditDeviceTypeChannels='edit_device_type_channnels'
const Endpoits_Charts='charts'

const pathToPageTitle: { [key: string]: string } = {
    ['/dashboard/' + Endpoits_Channels]: Title_Channels,
    ['/dashboard/' + Endpoits_Devices]: Title_Devices,
    ['/dashboard/' + Endpoits_DataList]: Title_DataList,
    ['/dashboard/' + Endpoits_EditUsers]: Title_EditUsers,
    ['/dashboard/' + Endpoits_EditDevices]: Title_EditDevices,
    ['/dashboard/' + Endpoits_EditChannels]: Title_EditChannels,
    ['/dashboard/' + Endpoits_EditGroups]: Title_EditGroups,
    ['/dashboard/' + Endpoits_EditSensorTypes]: Title_EditSensorTypes,
    ['/dashboard/' + Endpoits_EditDeviceTypes]: Title_EditDeviceTypes,
    ['/dashboard/' + Endpoits_EditDeviceTypeChannels]: Title_EditDeviceTypeChannels,
    ['/dashboard/' + Endpoits_Charts]: Title_Charts,
  };

const UserNameDisplay = () => {
  const [fullName, setFullName] = useState('');

  useEffect(() => {
    const storedName = localStorage.getItem('full_name');
    if (storedName) {
      setFullName(storedName);
    }
  }, []);

  return (
    <Typography component="div" variant="body1" color="inherit">
      {fullName}
    </Typography>
  );
};

export const Dashboard: FC = () => {
  //const [chartDialogOpen, setChartDialogOpen] = useState(false);
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();

  const pageTitle = pathToPageTitle[location.pathname] ?? '';

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (path: string) => {
    navigate(path);
    handleClose();
  };

  const handleClick = () => {
    //reload current route
    navigate(0);
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <AppBar position="absolute">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleMenu}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, ml: 2 }}>
            {pageTitle}
          </Typography>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem dense onClick={() => handleMenuItemClick(Endpoits_Channels)}>
              <ListItemIcon>
                <ListAltOutlinedIcon/>
              </ListItemIcon>
              <ListItemText>{Title_Channels}</ListItemText>
            </MenuItem>
            <MenuItem dense onClick={() => handleMenuItemClick(Endpoits_Devices)}>
              <ListItemIcon>
                <ListAltOutlinedIcon/>
              </ListItemIcon>
              <ListItemText>{Title_Devices}</ListItemText>
            </MenuItem>
            {/*
            グラフ表示は今後追加する可能性はあるが現段階では削除とする
            <MenuItem dense onClick={() => { handleClose(); setChartDialogOpen(true); }}>
              <ListItemIcon>
                <SsidChartOutlinedIcon/>
              </ListItemIcon>
              <ListItemText>{Title_Charts}</ListItemText>
            </MenuItem>
            */}
            <MenuItem dense onClick={() => handleMenuItemClick(Endpoits_DataList)}>
              <ListItemIcon>
                <ListAltOutlinedIcon/>
              </ListItemIcon>
              <ListItemText>{Title_DataList}</ListItemText>
            </MenuItem>
            <Divider/>
            <MenuItem dense onClick={() => { handleClose(); setExportDialogOpen(true); }}>
              <ListItemIcon>
                <CloudDownloadOutlinedIcon/>
              </ListItemIcon>
              <ListItemText>{Title_Exports}</ListItemText>
            </MenuItem>
            <Divider/>
            {isAdmin() && (
              <>
                <MenuItem dense onClick={() => handleMenuItemClick(Endpoits_EditUsers)}>
                  <ListItemIcon>
                    <SettingsOutlinedIcon/>
                  </ListItemIcon>
                  <ListItemText>{Title_EditUsers}</ListItemText>
                </MenuItem>
                <MenuItem dense onClick={() => handleMenuItemClick(Endpoits_EditDevices)}>
                  <ListItemIcon>
                    <SettingsOutlinedIcon/>
                  </ListItemIcon>
                  <ListItemText>{Title_EditDevices}</ListItemText>
                </MenuItem>
                <MenuItem dense onClick={() => handleMenuItemClick(Endpoits_EditChannels)}>
                  <ListItemIcon>
                    <SettingsOutlinedIcon/>
                  </ListItemIcon>
                  <ListItemText>{Title_EditChannels}</ListItemText>
                </MenuItem>
                <MenuItem dense onClick={() => handleMenuItemClick(Endpoits_EditGroups)}>
                  <ListItemIcon>
                    <SettingsOutlinedIcon/>
                  </ListItemIcon>
                  <ListItemText>{Title_EditGroups}</ListItemText>
                </MenuItem>
                <MenuItem dense onClick={() => handleMenuItemClick(Endpoits_EditSensorTypes)}>
                  <ListItemIcon>
                    <SettingsOutlinedIcon/>
                  </ListItemIcon>
                  <ListItemText>{Title_EditSensorTypes}</ListItemText>
                </MenuItem>
                <MenuItem dense onClick={() => handleMenuItemClick(Endpoits_EditDeviceTypes)}>
                  <ListItemIcon>
                    <SettingsOutlinedIcon/>
                  </ListItemIcon>
                  <ListItemText>{Title_EditDeviceTypes}</ListItemText>
                </MenuItem>
                <MenuItem dense onClick={() => handleMenuItemClick(Endpoits_EditDeviceTypeChannels)}>
                  <ListItemIcon>
                    <SettingsOutlinedIcon/>
                  </ListItemIcon>
                  <ListItemText>{Title_EditDeviceTypeChannels}</ListItemText>
                </MenuItem>
                <Divider />
              </>
            )}
            <MenuItem dense onClick={() => { navigate('/logout'); handleClose(); }}>
              <ListItemIcon>
                <LogoutOutlinedIcon/>
              </ListItemIcon>
              <ListItemText>ログアウト</ListItemText>
            </MenuItem>
          </Menu>
          {/*
          <ChartDialog
            open={chartDialogOpen}
            onClose={() => setChartDialogOpen(false)}
            onApply={(dateFrom: Date|null, dateTo: Date|null, isPreviousYear: boolean) => {
                setChartDialogOpen(false);
                let url = 'charts';
                url = `${url}?from=${toLocal(dateFrom ?? new Date()).toISOString().slice(0,10)}`;
                url = `${url}&to=${toLocal(dateTo ?? new Date()).toISOString().slice(0,10)}`;
                url = `${url}&isPreviousYear=${isPreviousYear}`;
                navigate(url);
              }}
          />
          */}
          {exportDialogOpen && (
            <ExportDialog open={exportDialogOpen} onClose={() => setExportDialogOpen(false)} />
          )}
          <Typography component="div" variant="h5" sx={{ flexGrow: 1 }}>
            
          </Typography>
          <UserNameDisplay />
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
          </IconButton>
          <Button
            color="inherit"
            onClick={handleClick}
            variant="outlined"
            >
            <RefreshOutlinedIcon sx={{ml: -0.5}}/>
              更新
          </Button>
        </Toolbar>
      </AppBar>
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        <Toolbar />
        <Box>
          <Routes>
            {/*<Route path={Endpoits_Charts} element={<Charts/>}/>*/}
            <Route path={Endpoits_Channels} element={<Channels/>}/>
            <Route path={Endpoits_DataList} element={<DataList/>}/>
            <Route path={Endpoits_Devices} element={<Devices/>}/>
            <Route path={Endpoits_EditUsers} element={<EditUsers/>}/>
            <Route path={Endpoits_EditDevices} element={<EditDevices/>}/>
            <Route path={Endpoits_EditChannels} element={<EditChannels/>}/>
            <Route path={Endpoits_EditGroups} element={<EditGroups/>}/>
            <Route path={Endpoits_EditSensorTypes} element={<EditSensorTypes/>}/>
            <Route path={Endpoits_EditDeviceTypes} element={<EditDeviceTypes/>}/>
            <Route path={Endpoits_EditDeviceTypeChannels} element={<EditDeviceTypeChannels/>}/>
            <Route path="*" element={<Navigate to={Endpoits_Channels} replace />}/>
          </Routes>
        </Box>
        <Footer />
      </Box>
    </Box>
  );
};
